import axios from 'axios'

export default {
    getSubFoodCategoryList({commit}, params){
        return axios.post('/api/background/subsidiary_category/list', params)
    },
    addSubFoodCategory({commit}, params){
        return axios.post('/api/background/subsidiary_category/add', params)
    },
    modifySubFoodCategory({commit}, params){
        return axios.post('/api/background/subsidiary_category/modify', params)
    },
    deleteSubFoodCategory({commit}, params){
        return axios.post('/api/background/subsidiary_category/delete', params)
    },
    getSubFoodList({commit}, params){
        return axios.post('/api/background/subsidiary_food/list', params)
    },
    addSubFood({commit}, params){
        return axios.post('/api/background/subsidiary_food/add', params)
    },
    modifySubFood({commit}, params){
        return axios.post('/api/background/subsidiary_food/modify', params)
    },
    deleteSubFood({commit}, params){
        return axios.post('/api/background/subsidiary_food/delete', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/subfood.js